const loanSections = [
  {
    id: "home-loan",
    title: "HDFC Home Loan Premium Calculator",
    subtitle: "SBI Online Housing Loan EMI Calculator",
    description:
      "Calculate your home loan EMI for HDFC, SBI, and Axis Bank. Our tool provides accurate monthly installment calculations with current interest rates starting from 8.25% p.a.",
    features: [
      "HDFC Home Loan rates from 8.25% p.a.",
      "SBI Housing Loan rates from 8.40% p.a.",
      "Axis Bank Home Loan rates from 8.55% p.a.",
      "Full amortization schedule with balance reduction",
    ],
    defaultRate: "8.25% - 9.50%",
    maxTenure: "30 Years",
    color: "blue",
  },
  {
    id: "car-loan",
    title: "India Car Loan Calculator",
    subtitle: "HDFC Second Hand Car Loan Calculator & Online SBI Car Loan Calculator",
    description:
      "Whether you are buying a new car or a pre-owned vehicle, calculate your car loan EMI instantly. Compare rates from HDFC, SBI, and other leading banks for both new and second-hand car loans in India.",
    features: [
      "New car loan rates from 7.25% p.a.",
      "HDFC second hand car loan calculation",
      "SBI car loan EMI with flexible tenure",
      "Down payment impact on monthly EMI",
    ],
    defaultRate: "7.25% - 12.50%",
    maxTenure: "7 Years",
    color: "sky",
  },
  {
    id: "personal-loan",
    title: "Online SBI Personal Loan Calculator",
    subtitle: "5 Lakh Personal Loan Calculator | Personal Loan Calculator INR",
    description:
      "Calculate EMI for personal loans starting from 5 lakh to 40 lakh. Our personal loan calculator in INR gives you instant results for SBI, HDFC, and ICICI personal loan interest rates.",
    features: [
      "5 lakh personal loan EMI calculation",
      "SBI personal loan rates from 10.75% p.a.",
      "HDFC personal loan rates from 10.50% p.a.",
      "Personal loan calculator with GST on processing fee",
    ],
    defaultRate: "10.50% - 16.00%",
    maxTenure: "5 Years",
    color: "indigo",
  },
]

export default function LoanSections() {
  return (
    <div className="py-16 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 space-y-16">
        {loanSections.map((section) => (
          <section key={section.id} id={section.id} className="scroll-mt-20" aria-labelledby={`${section.id}-heading`}>
            <div className="bg-white rounded-2xl shadow-md border border-slate-100 overflow-hidden">
              <div className="p-6 md:p-10">
                <h2 id={`${section.id}-heading`} className="text-2xl md:text-3xl font-bold text-slate-800 mb-2">
                  {section.title}
                </h2>
                <p className="text-base md:text-lg text-blue-600 font-medium mb-4">{section.subtitle}</p>
                <p className="text-slate-600 leading-relaxed max-w-3xl mb-6">{section.description}</p>

                <div className="grid sm:grid-cols-2 gap-3 mb-6">
                  {section.features.map((feature) => (
                    <div key={feature} className="flex items-start gap-2">
                      <svg className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-sm text-slate-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-4 items-center">
                  <div className="bg-slate-50 px-4 py-2 rounded-lg">
                    <span className="text-xs text-slate-500">Interest Rate</span>
                    <p className="text-sm font-bold text-slate-800">{section.defaultRate}</p>
                  </div>
                  <div className="bg-slate-50 px-4 py-2 rounded-lg">
                    <span className="text-xs text-slate-500">Max Tenure</span>
                    <p className="text-sm font-bold text-slate-800">{section.maxTenure}</p>
                  </div>
                  <a
                    href="#calculator"
                    className="ml-auto inline-flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-medium px-5 py-2.5 rounded-xl transition-colors text-sm"
                  >
                    Calculate EMI
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  )
}
